import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import "../assets/css/login.css";

const initializeTheme = () => {
  const savedTheme = Cookies.get("isDarkMode");
  if (savedTheme !== undefined) {
    return savedTheme === "true";
  }
  return (
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );
};

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDarkMode] = useState(initializeTheme());

  // Apply theme
  useEffect(() => {
    document.body.setAttribute("data-theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  // Auto-hide error after 5 seconds
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(
        email,
        {
          redirectTo: `${window.location.origin}/reset-password`,
        }
      );

      if (resetError) {
        if (resetError.status === 429) {
          setError("Too many requests. Please try again in a few minutes.");
        } else {
          setError(resetError.message || "Something went wrong. Please try again.");
        }
        setIsLoading(false);
        return;
      }

      // Always show success (even if email doesn't exist - prevents user enumeration)
      setSuccess(true);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container-bg">
      <div className="login-forgot-wrapper">
        <div className="login-card-custom login-form-animated">
          {/* Header */}
          <div className="login-forgot-header">
            <div className="login-forgot-icon">
              <i className="bi bi-key"></i>
            </div>
            <h2 className="login-forgot-title">Reset your password</h2>
            <p className="login-forgot-subtitle">
              Enter your email and we'll send you a reset link
            </p>
          </div>

          {!success ? (
            <form onSubmit={handleSubmit}>
              {error && (
                <div className="login-error-alert">
                  <i className="bi bi-exclamation-circle"></i>
                  {error}
                </div>
              )}

              <div className="login-form-group">
                <label htmlFor="forgot-email">Email Address</label>
                <input
                  type="email"
                  className="form-control login-input-custom"
                  id="forgot-email"
                  value={email}
                  placeholder="Enter your email address"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <button
                type="submit"
                className="login-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ marginRight: "8px" }}
                    ></span>
                    Sending...
                  </>
                ) : (
                  "Send Reset Link"
                )}
              </button>
            </form>
          ) : (
            <div className="login-success-state">
              <div className="login-success-icon">
                <i className="bi bi-envelope-check"></i>
              </div>
              <h3>Check your email</h3>
              <p>
                If an account exists for <strong>{email}</strong>, you will
                receive a password reset link shortly.
              </p>
            </div>
          )}

          <div className="login-back-link">
            <Link to="/login">
              <i className="bi bi-arrow-left"></i> Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
